import React, { useEffect, useState } from 'react';
import { default as t } from '../../../utils/i18n';
import { AppTooltip } from '..';

import './date-range-picker.scss';
import { CheckPicker, DatePicker, DateRangePicker, InputGroup } from 'rsuite';

const { allowedMaxDays, allowedDays, allowedRange, beforeToday, afterToday, combine, after, before } =
  DateRangePicker;

const DateRangepicker = ({ heading, format, size, placeholder1, placeholder2,  
  type, value, onOk, tooltipIndicator = false,
  tooltipId = '', infoData = '' , isImportant = false}) => {
  const [values, setValue] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateDisable, setStartDateDisable] = useState(false);
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [dateRangeValue, setDateRangeValue] = useState(null);

  let date = new Date()
  let threeYearBeforedate = date.setMonth(date.getMonth() - 36);
  
  const onStartDateChange = val => {
    if (val && val !== null) {
      setStartDate(new Date(val));
      setEndDateDisable(false);
      setEndDate(null);
    } else {
      setStartDate(val);
      setEndDate(null);
      setDateRangeValue(null);
      setEndDateDisable(true);
    }
  }

  const onEndDateChange = val => {
    if (val && val !== null) {
      setEndDate(new Date(val));
      setDateRangeValue([new Date(startDate), new Date(val)]);
    } else {
      setEndDate(val);
      setDateRangeValue(null);
    }
  }

  useEffect(() => {
    if (value && value !== null) {
      setStartDate(new Date(value[0]));
      setEndDate(new Date(value[1]));
      setEndDateDisable(false);
    } else {
      setStartDate(null);
      setEndDate(null);
      setDateRangeValue(null);
      setEndDateDisable(true);
    }
  }, [value]);

  useEffect(() => {
    onOk(dateRangeValue);
  }, [dateRangeValue]);

  return (
    <div className='c-dropdown'>
      <div className={tooltipIndicator ? "header" : 'c-dropdown'}>
        <h3 className='c-text-heading-3'>{heading} {isImportant ? <span className='imp-icon'>*</span>: ''}</h3>
        {tooltipIndicator ?
          <span>
            <i className="eva eva-info-outline" data-tip={infoData} data-for={tooltipId}></i>
            <AppTooltip className="c-table-info-icon--tooltip" id={tooltipId} place='right' />
          </span> : null}
      </div>

      <div className='date-range'>
        <DatePicker
          id="start-date"
          disabled={startDateDisable}
          format={format}
          size={size}
          placement="bottomStart"
          value={startDate}
          onChange={onStartDateChange}
          disabledDate={type? type != 'live' ? allowedRange(threeYearBeforedate, new Date()) : allowedRange(threeYearBeforedate, new Date()) : null}
          placeholder={placeholder1}
          oneTap
        />
        <div className='date-range-to'>{t('report.client.reporting.to')}</div>
        <DatePicker
          id="end-date"
          disabled={endDateDisable}
          format={format}
          size={size}
          placement="bottomEnd"
          value={endDate}
          onChange={onEndDateChange}
          disabledDate={type? type != 'live' ? allowedRange(startDate, new Date()) : before(startDate) : before(startDate)}
          placeholder={placeholder2}
          oneTap
        />
      </div>
    </div>
  );
};

export default DateRangepicker;
